import { useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import { DesktopStepper } from './components/DesktopStepper';
import { MyMobileStepper } from './components/MyMobileStepper';
import { useNewAccountState } from './hooks/useNewAccountState';
import { NewAccountStepperProvider } from './context/NewAccountStepperContext';

const NewAccountStepper: React.FC = () => {
  const {
    activeStep,
    handleNext,
    handleBack,
    isLastStep,
    saveError,
    handleSave,
    handleReset,
    warningMessage,
    showWarning,
    updateStepValidation,
    goToLastStep,
    numOfSteps,
    setActiveStep,
  } = useNewAccountState();

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('md'));
  const contextValue = {
    activeStep,
    handleNext,
    handleBack,
    handleReset,
    isLastStep,
    handleSave,
    error: saveError,
    warningMessage,
    showWarning,
    updateStepValidation,
    goToLastStep,
    numOfSteps,
    setActiveStep,
  };

  return (
    <NewAccountStepperProvider value={contextValue}>
      {matches ? <DesktopStepper /> : <MyMobileStepper />}
    </NewAccountStepperProvider>
  );
};

export default NewAccountStepper;
